import React from "react";

function OverdueSvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g
          id="Group_8576"
          data-name="Group 8576"
          transform="translate(-8751 992)"
        >
          <g
            id="Group_8575"
            data-name="Group 8575"
            transform="translate(8747.474 -993.526)"
          >
            <g
              id="Group_8574"
              data-name="Group 8574"
              transform="translate(12 12)"
            >
              <path
                id="Path_40081"
                data-name="Path 40081"
                d="M15.526,12a3.526,3.526,0,1,0,3.526,3.526A3.528,3.528,0,0,0,15.526,12Zm1.164,5.184-1.516-1.516V13.411h.705v1.968l1.3,1.3Z"
                transform="translate(-12 -12)"
                fill="#d7242e"
              />
            </g>
          </g>
          <g id="event_busy_black_24dp" transform="translate(8751 -992)">
            <path
              id="Path_40083"
              data-name="Path 40083"
              d="M0,0H24V24H0Z"
              fill="none"
            />
            <path
              id="Path_40084"
              data-name="Path 40084"
              d="M19,3H18V1H16V3H8V1H6V3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Zm0,16H5V9H19ZM5,7V5H19V7Z"
              fill="#d7242e"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}

export default OverdueSvgComponent;
